// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-pc-bulletin-default__footer{padding:17px 0 24px;text-align:center}.plv-iar-module-container--bulletin .plv-iar-module-container-default__body{overflow:hidden}.plv-iar-module-container--bulletin .plv-iar-module-container-default__body>div{height:100%}.plv-iar-bulletin__return-list{position:absolute;top:0;right:0;font-size:14px;color:#2196f3;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
